import webserviceWrapper from "../_helpers/webserviceWrapper";

export const adminservice={
    GetCategoryAndSubCategoryList,
    GetQuestionBankList,
    SaveQuestionBank,
    DeleteSelectedQuestion,
    AddEditMemberRegistration,
    GetData,
    GetMemberList,
    DeleteMember,
    GetMemberDetail,
    GetStudentList,
    GetQuestionBankListMEO,
    DeleteSelectedQuestionforMeo,
    DeleteStudent,
    GetStudentDetail,
    UploadExcelSheet,
    ExportMemberDetails,
    ExportStudentDetails,
    GetMemberListBasedonClass,
    ExportMemberListBasedonClass,
}

function GetCategoryAndSubCategoryList(){
    return webserviceWrapper.get(
        `AdminQuestion/GetCategoryAndSubCategoryList`
    );
}

function GetQuestionBankList(){
    return webserviceWrapper.get(
        `AdminQuestion/GetQuestionBankList`
    );
}

function SaveQuestionBank(data){
    return webserviceWrapper.post(
        `AdminQuestion/SaveQuestionBank`,
        data
    );
}

function DeleteSelectedQuestion(questionBankId){
    return webserviceWrapper.post(
        `AdminQuestion/DeleteSelectedQuestion`,
        {questionBankId}
    );
}

/* <summary>
date: 04-07-2022
Name: VD
description: This is called when the admin wants to register or update a particular member
<summary>*/ 
function AddEditMemberRegistration(registerModel){
    return webserviceWrapper.post(
        `AdminUser/AddEditMemberRegistration`,
        registerModel
    );
}


function GetData(){
    return webserviceWrapper.get(
        `AdminUser/GetData`
    );
}

function GetMemberList(prevPageValue,noOfRecordsToFetch,searchedName,isActive){
    return webserviceWrapper.post(
        `AdminUser/GetMemberList`,
        {prevPageValue,noOfRecordsToFetch,searchedName,isActive},
        60000
    );
}

function DeleteMember(memberId){
    return webserviceWrapper.post(
        `AdminUser/DeleteMember`,
        {memberId}
    );
}

function GetMemberDetail(memberId){
    return webserviceWrapper.post(
        `AdminUser/GetMemberDetail`,
        {memberId}
    );
}

function GetStudentList(prevPageValue,noOfRecordsToFetch,searchedName,isActive){
    return webserviceWrapper.post(
        `AdminUser/GetStudentList`,
        {prevPageValue,noOfRecordsToFetch,searchedName,isActive}
    );
}

function GetQuestionBankListMEO(){
    return webserviceWrapper.get(
        `AdminQuestion/GetQuestionBankListMEO`
    );
}

function DeleteSelectedQuestionforMeo(questionBankId){
    return webserviceWrapper.post(
        `AdminQuestion/DeleteSelectedQuestionforMeo`,
        {questionBankId}
    );
}

function DeleteStudent(userId){
    return webserviceWrapper.post(
        `AdminUser/DeleteStudent`,
        {userId}
    );
}

function GetStudentDetail(userId){
    return webserviceWrapper.post(
        `AdminUser/GetStudentDetail`,
        {userId}
    );
}

function UploadExcelSheet(data){
    return webserviceWrapper.post(
        `AdminUser/UploadExcelSheet`,
        data
    );
}

function ExportMemberDetails(isActive){
    return webserviceWrapper.post(
        `AdminUser/ExportMemberDetails`,
        {isActive}
    );
}

function ExportStudentDetails(isActive){
    return webserviceWrapper.post(
        `AdminUser/ExportStudentDetails`,
        {isActive}
    );
}

function GetMemberListBasedonClass(prevPageValue,noOfRecordsToFetch,searchedName,grade){
    return webserviceWrapper.post(
        `AdminUser/GetMemberListBasedonClass`,
        {prevPageValue,noOfRecordsToFetch,searchedName,grade}
    );
}

function ExportMemberListBasedonClass(grade){
    return webserviceWrapper.post(
        `AdminUser/ExportMemberListBasedonClass`,
        {grade}
    );
}